export default function ServerErrorPage(){
    return(
        <>
            500 error page
        </>
    )
}